import { render, staticRenderFns } from "./SoftwareDisplay.vue?vue&type=template&id=6af04de8&scoped=true"
import script from "./SoftwareDisplay.vue?vue&type=script&lang=js"
export * from "./SoftwareDisplay.vue?vue&type=script&lang=js"
import style0 from "./SoftwareDisplay.vue?vue&type=style&index=0&id=6af04de8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af04de8",
  null
  
)

export default component.exports